export const productsData = {
  // 女清爽舒適棉質附吸汗墊片細肩帶
  4548076761136: {
    name: '女清爽舒適棉質附吸汗墊片細肩帶',
    number: '4548076761136',
    price: '390',
    img: {
      white_bg: '4548076761136_1260.jpg',
      usage: '',
    },
    alt: '白色',
  },
  4548076761310: {
    name: '女清爽舒適棉質附吸汗墊片細肩帶',
    number: '4548076761310',
    price: '390',
    img: {
      white_bg: '4548076761310_1260.jpg',
      usage: '',
    },
    alt: '米黃',
  },
  4548076761198: {
    name: '女清爽舒適棉質附吸汗墊片細肩帶',
    number: '4548076761198',
    price: '390',
    img: {
      white_bg: '4548076761198_1260.jpg',
      usage: '',
    },
    alt: '灰白',
  },
  4548076761259: {
    name: '女清爽舒適棉質附吸汗墊片細肩帶',
    number: '4548076761259',
    price: '390',
    img: {
      white_bg: '4548076761259_1260.jpg',
      usage: '',
    },
    alt: '黑色',
  },
  // 女清爽舒適棉質附吸汗墊片坦克背心
  4548076762577: {
    name: '女清爽舒適棉質附吸汗墊片坦克背心',
    number: '4548076762577',
    price: '390',
    img: {
      white_bg: '4548076762577_1260.jpg',
      usage: '',
    },
    alt: '白色',
  },
  4548076762904: {
    name: '女清爽舒適棉質附吸汗墊片坦克背心',
    number: '4548076762904',
    price: '390',
    img: {
      white_bg: '4548076762904_1260.jpg',
      usage: '',
    },
    alt: '米黃',
  },
  4548076762782: {
    name: '女清爽舒適棉質附吸汗墊片坦克背心',
    number: '4548076762782',
    price: '390',
    img: {
      white_bg: '4548076762782_1260.jpg',
      usage: '',
    },
    alt: '灰白',
  },
  4548076762843: {
    name: '女清爽舒適棉質附吸汗墊片坦克背心',
    number: '4548076762843',
    price: '390',
    img: {
      white_bg: '4548076762843_1260.jpg',
      usage: '',
    },
    alt: '黑色',
  },
  // 女清爽舒適棉質輕薄細肩帶
  4548076761860: {
    name: '女清爽舒適棉質輕薄細肩帶',
    number: '4548076761860',
    price: '390',
    img: {
      white_bg: '4548076761860_1260.jpg',
      usage: '',
    },
    alt: '白色',
  },
  4548076762041: {
    name: '女清爽舒適棉質輕薄細肩帶',
    number: '4548076762041',
    price: '390',
    img: {
      white_bg: '4548076762041_1260.jpg',
      usage: '',
    },
    alt: '淡桃紅',
  },
  4548076761921: {
    name: '女清爽舒適棉質輕薄細肩帶',
    number: '4548076761921',
    price: '390',
    img: {
      white_bg: '4548076761921_1260.jpg',
      usage: '',
    },
    alt: '灰白',
  },
  4548076761983: {
    name: '女清爽舒適棉質輕薄細肩帶',
    number: '4548076761983',
    price: '390',
    img: {
      white_bg: '4548076761983_1260.jpg',
      usage: '',
    },
    alt: '黑色',
  },
  // 女清爽舒適棉質輕薄坦克背心
  4548076765127: {
    name: '女清爽舒適棉質輕薄坦克背心',
    number: '4548076765127',
    price: '390',
    img: {
      white_bg: '4548076765127_1260.jpg',
      usage: '',
    },
    alt: '白色',
  },
  4548076765189: {
    name: '女清爽舒適棉質輕薄坦克背心',
    number: '4548076765189',
    price: '390',
    img: {
      white_bg: '4548076765189_1260.jpg',
      usage: '',
    },
    alt: '灰白',
  },
  4548076765240: {
    name: '女清爽舒適棉質輕薄坦克背心',
    number: '4548076765240',
    price: '390',
    img: {
      white_bg: '4548076765240_1260.jpg',
      usage: '',
    },
    alt: '黑色',
  },
  4548076765301: {
    name: '女清爽舒適棉質輕薄坦克背心',
    number: '4548076765301',
    price: '390',
    img: {
      white_bg: '4548076765301_1260.jpg',
      usage: '',
    },
    alt: '淡桃紅',
  },
  // 女清爽舒適棉質直角襪
  4548076824176: {
    name: '女清爽舒適棉質直角襪',
    number: '4548076824176',
    price: '99',
    img: {
      white_bg: '4548076824176_1260.jpg',
      usage: '',
    },
    alt: '白色',
  },
  4548076824510: {
    name: '女清爽舒適棉質直角襪',
    number: '4548076824510',
    price: '99',
    img: {
      white_bg: '4548076824510_1260.jpg',
      usage: '',
    },
    alt: '淺灰',
  },
  4548076824534: {
    name: '女清爽舒適棉質直角襪',
    number: '4548076824534',
    price: '99',
    img: {
      white_bg: '4548076824534_1260.jpg',
      usage: '',
    },
    alt: '深灰',
  },
  4548076824558: {
    name: '女清爽舒適棉質直角襪',
    number: '4548076824558',
    price: '99',
    img: {
      white_bg: '4548076824558_1260.jpg',
      usage: '',
    },
    alt: '黑色',
  },
  4548076824572: {
    name: '女清爽舒適棉質直角襪',
    number: '4548076824572',
    price: '99',
    img: {
      white_bg: '4548076824572_1260.jpg',
      usage: '',
    },
    alt: '淺黃',
  },
  4548076824596: {
    name: '女清爽舒適棉質直角襪',
    number: '4548076824596',
    price: '99',
    img: {
      white_bg: '4548076824596_1260.jpg',
      usage: '',
    },
    alt: '淺藍',
  },
  4548076824640: {
    name: '女清爽舒適棉質直角襪',
    number: '4548076824640',
    price: '99',
    img: {
      white_bg: '4548076824640_1260.jpg',
      usage: '',
    },
    alt: '淡棕',
  },
  // 女清爽舒適棉質直角短襪
  4548076821724: {
    name: '女清爽舒適棉質直角短襪',
    number: '4548076821724',
    price: '99',
    img: {
      white_bg: '4548076821724_1260.jpg',
      usage: '',
    },
    alt: '白色',
  },
  4548076821748: {
    name: '女清爽舒適棉質直角短襪',
    number: '4548076821748',
    price: '99',
    img: {
      white_bg: '4548076821748_1260.jpg',
      usage: '',
    },
    alt: '淺灰',
  },
  4548076821762: {
    name: '女清爽舒適棉質直角短襪',
    number: '4548076821762',
    price: '99',
    img: {
      white_bg: '4548076821762_1260.jpg',
      usage: '',
    },
    alt: '深灰',
  },
  4548076821786: {
    name: '女清爽舒適棉質直角短襪',
    number: '4548076821786',
    price: '99',
    img: {
      white_bg: '4548076821786_1260.jpg',
      usage: '',
    },
    alt: '黑色',
  },
  4548076821809: {
    name: '女清爽舒適棉質直角短襪',
    number: '4548076821809',
    price: '99',
    img: {
      white_bg: '4548076821809_1260.jpg',
      usage: '',
    },
    alt: '淺黃',
  },
  4548076821830: {
    name: '女清爽舒適棉質直角短襪',
    number: '4548076821830',
    price: '99',
    img: {
      white_bg: '4548076821830_1260.jpg',
      usage: '',
    },
    alt: '淺藍',
  },
  4548076821854: {
    name: '女清爽舒適棉質直角短襪',
    number: '4548076821854',
    price: '99',
    img: {
      white_bg: '4548076821854_1260.jpg',
      usage: '',
    },
    alt: '淡棕',
  },
  // 女清爽舒適棉質淺口直角襪
  4548076820321: {
    name: '女清爽舒適棉質淺口直角襪',
    number: '4548076820321',
    price: '99',
    img: {
      white_bg: '4548076820321_1260.jpg',
      usage: '',
    },
    alt: '白色',
  },
  4548076820345: {
    name: '女清爽舒適棉質淺口直角襪',
    number: '4548076820345',
    price: '99',
    img: {
      white_bg: '4548076820345_1260.jpg',
      usage: '',
    },
    alt: '淺灰',
  },
  4548076820369: {
    name: '女清爽舒適棉質淺口直角襪',
    number: '4548076820369',
    price: '99',
    img: {
      white_bg: '4548076820369_1260.jpg',
      usage: '',
    },
    alt: '深灰',
  },
  4548076820383: {
    name: '女清爽舒適棉質淺口直角襪',
    number: '4548076820383',
    price: '99',
    img: {
      white_bg: '4548076820383_1260.jpg',
      usage: '',
    },
    alt: '黑色',
  },
  4548076820406: {
    name: '女清爽舒適棉質淺口直角襪',
    number: '4548076820406',
    price: '99',
    img: {
      white_bg: '4548076820406_1260.jpg',
      usage: '',
    },
    alt: '淺黃',
  },
  4548076820420: {
    name: '女清爽舒適棉質淺口直角襪',
    number: '4548076820420',
    price: '99',
    img: {
      white_bg: '4548076820420_1260.jpg',
      usage: '',
    },
    alt: '淺藍',
  },
  4548076820444: {
    name: '女清爽舒適棉質淺口直角襪',
    number: '4548076820444',
    price: '99',
    img: {
      white_bg: '4548076820444_1260.jpg',
      usage: '',
    },
    alt: '淡棕',
  },
  // 男清爽舒適棉質V領短袖T恤
  4550583468149: {
    name: '男清爽舒適棉質V領短袖T恤',
    number: '4550583468149',
    price: '390',
    img: {
      white_bg: '4550583468149_1260.jpg',
      usage: '',
    },
    alt: '白色',
  },
  4550583468200: {
    name: '男清爽舒適棉質V領短袖T恤',
    number: '4550583468200',
    price: '390',
    img: {
      white_bg: '4550583468200_1260.jpg',
      usage: '',
    },
    alt: '淺灰',
  },
  4550583468262: {
    name: '男清爽舒適棉質V領短袖T恤',
    number: '4550583468262',
    price: '390',
    img: {
      white_bg: '4550583468262_1260.jpg',
      usage: '',
    },
    alt: '黑色',
  },
  // 男清爽舒適棉質圓領短袖T恤
  4548076433422: {
    name: '男清爽舒適棉質圓領短袖T恤',
    number: '4548076433422',
    price: '390',
    img: {
      white_bg: '4548076433422_1260.jpg',
      usage: '',
    },
    alt: '白色',
  },
  4548076433484: {
    name: '男清爽舒適棉質圓領短袖T恤',
    number: '4548076433484',
    price: '390',
    img: {
      white_bg: '4548076433484_1260.jpg',
      usage: '',
    },
    alt: '淺灰',
  },
  4548076433545: {
    name: '男清爽舒適棉質圓領短袖T恤',
    number: '4548076433545',
    price: '390',
    img: {
      white_bg: '4548076433545_1260.jpg',
      usage: '',
    },
    alt: '黑色',
  },
  // 男清爽舒適棉質坦克背心
  4548076434146: {
    name: '男清爽舒適棉質坦克背心',
    number: '4548076434146',
    price: '390',
    img: {
      white_bg: '4548076434146_1260.jpg',
      usage: '',
    },
    alt: '白色',
  },
  4548076434207: {
    name: '男清爽舒適棉質坦克背心',
    number: '4548076434207',
    price: '390',
    img: {
      white_bg: '4548076434207_1260.jpg',
      usage: '',
    },
    alt: '淺灰',
  },
  4548076434269: {
    name: '男清爽舒適棉質坦克背心',
    number: '4548076434269',
    price: '390',
    img: {
      white_bg: '4548076434269_1260.jpg',
      usage: '',
    },
    alt: '黑色',
  },
  4550584503696: {
    name: '男清爽舒適棉質坦克背心',
    number: '4550584503696',
    price: '390',
    img: {
      white_bg: '4550584503696_1260.jpg',
      usage: '',
    },
    alt: '米色',
  },
  // 男清爽舒適棉質直角襪
  4548076832034: {
    name: '男清爽舒適棉質直角襪',
    number: '4548076832034',
    price: '99',
    img: {
      white_bg: '4548076832034_1260.jpg',
      usage: '',
    },
    alt: '黑色',
  },
  4548076832065: {
    name: '男清爽舒適棉質直角襪',
    number: '4548076832065',
    price: '99',
    img: {
      white_bg: '4548076832065_1260.jpg',
      usage: '',
    },
    alt: '暗藍',
  },
  // 男清爽舒適棉質直角短襪
  4548076829157: {
    name: '男清爽舒適棉質直角短襪',
    number: '4548076829157',
    price: '99',
    img: {
      white_bg: '4548076829157_1260.jpg',
      usage: '',
    },
    alt: '白色',
  },
  4548076829188: {
    name: '男清爽舒適棉質直角短襪',
    number: '4548076829188',
    price: '99',
    img: {
      white_bg: '4548076829188_1260.jpg',
      usage: '',
    },
    alt: '灰銀',
  },
  4548076829218: {
    name: '男清爽舒適棉質直角短襪',
    number: '4548076829218',
    price: '99',
    img: {
      white_bg: '4548076829218_1260.jpg',
      usage: '',
    },
    alt: '深灰',
  },
  4548076829249: {
    name: '男清爽舒適棉質直角短襪',
    number: '4548076829249',
    price: '99',
    img: {
      white_bg: '4548076829249_1260.jpg',
      usage: '',
    },
    alt: '黑色',
  },
  4548076829270: {
    name: '男清爽舒適棉質直角短襪',
    number: '4548076829270',
    price: '99',
    img: {
      white_bg: '4548076829270_1260.jpg',
      usage: '',
    },
    alt: '淡藍',
  },
  4548076829300: {
    name: '男清爽舒適棉質直角短襪',
    number: '4548076829300',
    price: '99',
    img: {
      white_bg: '4548076829300_1260.jpg',
      usage: '',
    },
    alt: '藍色',
  },
  4550584708961: {
    name: '男清爽舒適棉質直角短襪',
    number: '4550584708961',
    price: '99',
    img: {
      white_bg: '4550584708961_1260.jpg',
      usage: '',
    },
    alt: '暗藍',
  },
  4548076829362: {
    name: '男清爽舒適棉質直角短襪',
    number: '4548076829362',
    price: '99',
    img: {
      white_bg: '4548076829362_1260.jpg',
      usage: '',
    },
    alt: '淡棕',
  },
  4548076829393: {
    name: '男清爽舒適棉質直角短襪',
    number: '4548076829393',
    price: '99',
    img: {
      white_bg: '4548076829393_1260.jpg',
      usage: '',
    },
    alt: '仿古綠',
  },
  // 男清爽舒適棉質淺口直角襪
  4548076828433: {
    name: '男清爽舒適棉質淺口直角襪',
    number: '4548076828433',
    price: '99',
    img: {
      white_bg: '4548076828433_1260.jpg',
      usage: '',
    },
    alt: '白色',
  },
  4548076828464: {
    name: '男清爽舒適棉質淺口直角襪',
    number: '4548076828464',
    price: '99',
    img: {
      white_bg: '4548076828464_1260.jpg',
      usage: '',
    },
    alt: '灰銀',
  },
  4548076828495: {
    name: '男清爽舒適棉質淺口直角襪',
    number: '4548076828495',
    price: '99',
    img: {
      white_bg: '4548076828495_1260.jpg',
      usage: '',
    },
    alt: '深灰',
  },
  4548076828525: {
    name: '男清爽舒適棉質淺口直角襪',
    number: '4548076828525',
    price: '99',
    img: {
      white_bg: '4548076828525_1260.jpg',
      usage: '',
    },
    alt: '黑色',
  },
  4548076828556: {
    name: '男清爽舒適棉質淺口直角襪',
    number: '4548076828556',
    price: '99',
    img: {
      white_bg: '4548076828556_1260.jpg',
      usage: '',
    },
    alt: '淡藍',
  },
  4548076828587: {
    name: '男清爽舒適棉質淺口直角襪',
    number: '4548076828587',
    price: '99',
    img: {
      white_bg: '4548076828587_1260.jpg',
      usage: '',
    },
    alt: '藍色',
  },
  4548076828617: {
    name: '男清爽舒適棉質淺口直角襪',
    number: '4548076828617',
    price: '99',
    img: {
      white_bg: '4548076828617_1260.jpg',
      usage: '',
    },
    alt: '暗藍',
  },
  4548076828648: {
    name: '男清爽舒適棉質淺口直角襪',
    number: '4548076828648',
    price: '99',
    img: {
      white_bg: '4548076828648_1260.jpg',
      usage: '',
    },
    alt: '淡棕',
  },
  4548076828679: {
    name: '男清爽舒適棉質淺口直角襪',
    number: '4548076828679',
    price: '99',
    img: {
      white_bg: '4548076828679_1260.jpg',
      usage: '',
    },
    alt: '仿古綠',
  },
  // 男清爽舒適棉質商務直角襪
  4548076832485: {
    name: '男清爽舒適棉質商務直角襪',
    number: '4548076832485',
    price: '99',
    img: {
      white_bg: '4548076832485_1260.jpg',
      usage: '',
    },
    alt: '墨灰格紋',
  },
  4548076832508: {
    name: '男清爽舒適棉質商務直角襪',
    number: '4548076832508',
    price: '99',
    img: {
      white_bg: '4548076832508_1260.jpg',
      usage: '',
    },
    alt: '黑格紋',
  },
  4548076832522: {
    name: '男清爽舒適棉質商務直角襪',
    number: '4548076832522',
    price: '99',
    img: {
      white_bg: '4548076832522_1260.jpg',
      usage: '',
    },
    alt: '深藍格紋',
  },
  // 男清爽舒適棉質V領短袖T恤白色L
  4548076432708: {
    name: '男清爽舒適棉質V領短袖T恤白色',
    number: '4548076432708',
    price: '390',
    img: {
      white_bg: '4548076432708_1260.jpg',
      usage: '',
    },
    alt: '白色',
  },
  4548076432760: {
    name: '男清爽舒適棉質V領短袖T恤白色',
    number: '4548076432760',
    price: '390',
    img: {
      white_bg: '4548076432760_1260.jpg',
      usage: '',
    },
    alt: '淺灰',
  },
  4548076432821: {
    name: '男清爽舒適棉質V領短袖T恤白色',
    number: '4548076432821',
    price: '390',
    img: {
      white_bg: '4548076432821_1260.jpg',
      usage: '',
    },
    alt: '黑色',
  },
};

export const typeData = [
  {
    id: 1,
    title: '女裝',
    // gender: {
    //   img: 'feature-desktop.jpg',
    //   features: [
    //     {
    //       title: '天然由來的素材',
    //       description:
    //         '附吸汗墊片款式的內衣，<br>將棉與柔滑的莫代爾纖維<br>混紡而成。輕薄款式的內衣<br>採用了100％的有機棉。',
    //     },
    //     {
    //       title: '解決了不易乾燥的問題',
    //       description: '吸汗墊片變更為<br>雙層構造，減輕了洗滌後<br>不易乾燥的問題。',
    //     },
    //     {
    //       title: '重新檢視了布料的厚度',
    //       description: '在非附吸汗墊片款式的內衣方面，<br>我們選用了更輕薄的布料，<br>穿著時更加涼爽舒適。',
    //     },
    //   ],
    // },
    anchorTable: [
      {
        id: 1,
        td: [
          {
            text: '<span>清爽舒適棉質</span><span>附吸汗墊片</span>',
            anchor: '#category1-1',
          },
          {
            text: '',
            anchor: '#category1-1',
          },
          {
            text: '',
            anchor: '#category1-2',
          },
        ],
      },
      {
        id: 2,
        td: [
          {
            text: '<span>清爽舒適棉質</span><span>輕薄</span>',
            anchor: '#category2-1',
          },
          {
            text: '',
            anchor: '#category2-1',
          },
          {
            text: '',
            anchor: '#category2-2',
          },
        ],
      },
    ],
    categories: [
      {
        id: 1,
        heading: {
          title: '清爽舒適棉質',
          subtitle: '附吸汗墊片',
          description: '100%有機棉。<br>內墊可吸收汗水，<br>減少汗漬產生。',
          note: '※不包含領口與其他拼接布料部分',
          bg: 'blue',
        },
        blocks: [
          {
            id: 1,
            slides: ['women/1-1-slide1', 'women/1-1-slide2'],
            title: '清爽舒適棉質<br>附吸汗墊片細肩帶',
            description:
              '可調節式肩帶設計，可依身形調整穿著。內墊貼合腋下的袖口剪裁，能有效吸收汗水，防止汗漬沾染衣物。',
            products: [
              {
                id: 1,
                current_index: 3,
                no_chips: false,
                tag: '',
                items: ['4548076761136', '4548076761310', '4548076761198', '4548076761259'],
              },
            ],
          },
          {
            id: 2,
            slides: ['women/1-2-slide1', 'women/1-2-slide2', 'women/1-2-slide3'],
            title: '清爽舒適棉質<br>附吸汗墊片坦克背心',
            description:
              '重新調整肩部周圍設計，不易露出內衣肩帶。內墊貼合腋下的袖口剪裁，能確實吸收汗水，防止汗漬沾染衣物。',
            products: [
              {
                id: 1,
                current_index: 2,
                no_chips: false,
                tag: '',
                items: ['4548076762577', '4548076762904', '4548076762782', '4548076762843'],
              },
            ],
          },
        ],
      },
      {
        id: 2,
        heading: {
          title: '清爽舒適棉質',
          subtitle: '輕薄',
          description: '100%有機棉。<br>混紡高吸放濕棉纖維，<br>呈現輕盈的薄款質地。',
          note: '',
          bg: 'aqua',
        },
        blocks: [
          {
            id: 1,
            slides: ['women/2-1-slide1', 'women/2-1-slide2'],
            title: '清爽舒適棉質<br>輕薄細肩帶',
            description:
              '以不易在外搭衣物上顯痕為優先考量，將可調式肩帶設計得更細。同時改善背部肩帶部位的貼膚感。兼具適度貼合與不易悶熱的細肩帶背心。',
            products: [
              {
                id: 1,
                current_index: 0,
                no_chips: false,
                tag: '',
                items: ['4548076761860', '4548076761921', '4548076761983', '4548076762041'],
              },
            ],
          },
          {
            id: 2,
            slides: ['women/2-2-slide1', 'women/2-2-slide2'],
            title: '清爽舒適棉質<br>輕薄坦克背心',
            description: '將肩部設計得更細，呈現俐落、輕盈的造型。兼具適度貼合與不易悶熱的背心。',
            products: [
              {
                id: 1,
                current_index: 3,
                no_chips: false,
                tag: '',
                items: ['4548076765127', '4548076765189', '4548076765240', '4548076765301'],
              },
            ],
          },
        ],
      },
    ],
    more: {
      text: '瀏覽更多其他女內衣',
      link: 'https://shop.muji.tw/v2/official/SalePageCategory/483051?sortMode=Curator',
    },
    recommend: {
      products: [
        {
          id: 1,
          current_index: 0,
          no_chips: false,
          tag: '',
          items: [
            '4548076820321',
            '4548076820345',
            '4548076820369',
            '4548076820383',
            '4548076820406',
            '4548076820420',
            '4548076820444',
          ],
        },
        {
          id: 2,
          current_index: 3,
          no_chips: false,
          tag: '',
          items: [
            '4548076821724',
            '4548076821748',
            '4548076821762',
            '4548076821786',
            '4548076821809',
            '4548076821830',
            '4548076821854',
          ],
        },
        {
          id: 3,
          current_index: 1,
          no_chips: false,
          tag: '',
          items: [
            '4548076824176',
            '4548076824510',
            '4548076824534',
            '4548076824558',
            '4548076824572',
            '4548076824596',
            '4548076824640',
          ],
        },
      ],
    },
  },
  {
    id: 2,
    title: '男裝',
    categories: [
      {
        id: 1,
        heading: {
          title: '清爽舒適棉質',
          subtitle: '',
          description: '100%有機棉。<br />混紡提升吸放濕性的棉材質，<br />打造親膚、穿著舒適的觸感。',
          note: '※不包含領口與其他拼接布料部分',
          bg: 'blue',
        },
        blocks: [
          {
            id: 2,
            slides: ['men/1-1-slide1'],
            title: '清爽舒適棉質<br>V領短袖T恤',
            description:
              '基本版型的V領內衣。將領口周圍的布料做得較薄，內衣線條不易透出外衣的樣式。藉由在側邊縫合，衣物不易在洗滌後變形。',
            products: [
              {
                id: 1,
                current_index: 0,
                no_chips: false,
                tag: '',
                items: ['4548076432708', '4548076432760', '4548076432821'],
              },
            ],
          },
          {
            id: 2,
            slides: ['men/1-2-slide1'],
            title: '清爽舒適棉質<br>圓領短袖T恤',
            description:
              '為基本款圓領內著，領口貼邊採用較薄設計，不易在外搭上衣上留下痕跡，側邊加入縫線設計，洗滌後也不易變形。',
            products: [
              {
                id: 1,
                current_index: 0,
                no_chips: false,
                tag: '',
                items: ['4548076433422', '4548076433484', '4548076433545'],
              },
            ],
          },
          {
            id: 3,
            slides: ['men/1-3-slide1'],
            title: '清爽舒適棉質<br>坦克背心',
            description:
              '為基本款背心型內著，領口貼邊採用較薄設計，不易在外搭上衣上顯痕，側邊加入縫線設計，洗滌後也不易變形。',
            products: [
              {
                id: 1,
                current_index: 2,
                no_chips: false,
                tag: '',
                items: ['4548076434146', '4548076434207', '4548076434269', '4550584503696'],
              },
            ],
          },
        ],
      },
    ],
    more: {
      text: '瀏覽更多其他男內衣',
      link: 'https://shop.muji.tw/v2/official/SalePageCategory/483055?sortMode=Curator',
    },
    recommend: {
      products: [
        {
          id: 1,
          current_index: 0,
          no_chips: false,
          tag: '',
          items: [
            '4548076828433',
            '4548076828464',
            '4548076828495',
            '4548076828525',
            '4548076828556',
            '4548076828587',
            '4548076828617',
            '4548076828648',
            '4548076828679',
          ],
        },
        {
          id: 2,
          current_index: 1,
          no_chips: false,
          tag: '',
          items: [
            '4548076829157',
            '4548076829188',
            '4548076829218',
            '4548076829249',
            '4548076829270',
            '4548076829300',
            '4550584708961',
            '4548076829362',
            '4548076829393',
          ],
        },
        {
          id: 3,
          current_index: 0,
          no_chips: false,
          tag: '',
          items: ['4548076832034', '4548076832065'],
        },
        {
          id: 4,
          current_index: 0,
          no_chips: false,
          tag: '',
          items: ['4548076832485', '4548076832508', '4548076832522'],
        },
      ],
    },
  },
];

export const storiesData = [
  {
    id: 1,
    link: 'https://www.muji.tw/tw/pdf/',
    img: 'story01.jpg',
    text: '穿搭型錄',
  },
  {
    id: 2,
    link: 'https://shop.muji.tw/sb/style/',
    img: 'story02.jpg',
    text: 'Styling Advisor 穿搭圖輯',
  },
  {
    id: 3,
    link: 'https://www.muji.tw/tw/styling_advisor/',
    img: 'story03.jpg',
    text: '服飾搭配諮詢服務',
  },
  {
    id: 4,
    link: 'https://www.muji.tw/tw/feature/25aw/Lookbook-winter/',
    img: 'story04.jpg',
    text: '無印良品 2025｜冬季服飾穿搭',
  },
  {
    id: 5,
    link: 'https://www.muji.tw/tw/feature/24aw/socks/',
    img: 'story05.jpg',
    text: '365天都想穿的襪款',
  },
  {
    id: 6,
    link: 'https://www.muji.tw/tw/feature/suitcase/',
    img: 'story06.jpg',
    text: '四輪硬殼止滑拉桿箱',
  },
];
